import { useSyncExternalStore } from 'react'
import {
  getGuestLocale,
  setGuestLocale,
  subscribeGuestLocale,
  type GuestLocale,
} from '@/lib/guestLocale'
import { getLandingCopy, type LandingCopy } from '@/content/landing'

export function useGuestLocale(): GuestLocale {
  return useSyncExternalStore(subscribeGuestLocale, getGuestLocale, () => 'en')
}

export function useLandingCopy(): LandingCopy {
  const locale = useGuestLocale()
  return getLandingCopy(locale)
}

export function useSetGuestLocale(): (locale: GuestLocale) => void {
  return setGuestLocale
}
